// TODO: 数据状态是否要放到dataView

export type IScatterInvalidType = 'zero' | 'ignore';
export type IInvalidType = 'zero' | 'ignore' | 'link' | 'break';
